"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.StyleSheet = StyleSheet;
exports.keyframes = exports.css = void 0;

var _emotion = require("emotion");

var _elementStyles = require("@rexlabs/element-styles");

var keyframes = _emotion.keyframes;
exports.keyframes = keyframes;
var css = _emotion.css;
/**
 * The styles object is an object, where the keys are the identifiers you can use with
 * element styles.
 *
 * The values can be a string (= will be used as classname), an object of styles
 * (= will be turned into a classname using emotion) or a function. Functions indicate
 * dynamic styles and will be turned into styles separately. The function will receive
 * meta information e.g. tokens specific to the context (path and styles) the component
 * is rendered in.
 *
 * You can pass multiple of these values per key by using arrays.
 *
 * Element styles `splitStyles` does the detection for us and splits the value for each
 * key appropriately where needed.
 *
 * @param {Object} styles
 * @return {Objct}
 */

exports.css = css;

function StyleSheet(styles) {
  return (0, _elementStyles.splitStyles)(styles, css);
}

StyleSheet.setCreateClass = function (fn) {
  exports.css = css = fn;
};

StyleSheet.setKeyframes = function (fn) {
  exports.keyframes = keyframes = fn;
};